const dev = process.env.NODE_ENV !== "development";

const isDraftPost = (title, hidePost = dev) => {
  return title.toLowerCase().indexOf("draft") > -1 && hidePost;
};

module.exports = isDraftPost;
